var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgRightArrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.056 11.057c.521-.52 1.366-.52 1.886 0l8 8c.52.52.52 1.365 0 1.886l-8 8a1.333 1.333 0 01-1.886-1.886L22.114 20l-7.058-7.057a1.333 1.333 0 010-1.886z",
    fill: "#fff"
  })));
}

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDAiIGhlaWdodD0iNDAiIHZpZXdCb3g9IjAgMCA0MCA0MCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KCTxwYXRoIGZpbGwtcnVsZT0iZXZlbm9kZCIgY2xpcC1ydWxlPSJldmVub2RkIiBkPSJNMTUuMDU2NSAxMS4wNTcyQzE1LjU3NzIgMTAuNTM2NSAxNi40MjE1IDEwLjUzNjUgMTYuOTQyMiAxMS4wNTcyTDI0Ljk0MjIgMTkuMDU3MkMyNS40NjI5IDE5LjU3NzkgMjUuNDYyOSAyMC40MjIxIDI0Ljk0MjIgMjAuOTQyOEwxNi45NDIyIDI4Ljk0MjhDMTYuNDIxNSAyOS40NjM1IDE1LjU3NzIgMjkuNDYzNSAxNS4wNTY1IDI4Ljk0MjhDMTQuNTM1OCAyOC40MjIxIDE0LjUzNTggMjcuNTc3OSAxNS4wNTY1IDI3LjA1NzJMMjIuMTEzNyAyMEwxNS4wNTY1IDEyLjk0MjhDMTQuNTM1OCAxMi40MjIxIDE0LjUzNTggMTEuNTc3OSAxNS4wNTY1IDExLjA1NzJaIiBmaWxsPSIjZmZmIi8+Cjwvc3ZnPg==";
export { SvgRightArrow as ReactComponent };